import { render, staticRenderFns } from "./OutBoundInfo.vue?vue&type=template&id=5a3550e3&"
import script from "./OutBoundInfo.vue?vue&type=script&lang=js&"
export * from "./OutBoundInfo.vue?vue&type=script&lang=js&"
import style0 from "./OutBoundInfo.vue?vue&type=style&index=0&rel=stylesheet%2Fless&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports